import axios from 'axios'

let baseURL = 'https://api.jsgj888.top'

sessionStorage.setItem("baseURL", baseURL)

if(process.env.NODE_ENV=="development"){
  baseURL=''
}

let config = {
    baseURL: baseURL,
    timeout: 30000
}
const _axios = axios.create(config)

_axios.interceptors.request.use(
    config => {
        let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : ''

        config.headers.Authorization = 'Bearer ' + token;
        return config;
    },
    err => Promise.reject(err)
);

_axios.interceptors.response.use(
    res => {
        if (res.data.code === 1000) {

        }

        return res;
    },
    err => {
        if (err) {

        }
        return Promise.reject(err);
    }
);
// 天美社区源码网 timibbs.net timibbs.com timibbs.vip
const http = {
    get(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            _axios({
                url,
                params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8' },
                method: 'GET'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    },
    post(url = '', params = {}) {
        if (url == '/api/register' || url == '/api/login_pc') {
            sessionStorage.setItem("baseURL", baseURL)
        }
        return new Promise((resolve, reject) => {
            _axios({
                url,
                data: params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8' },
                method: 'POST'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    }
}


export default http



// WEBPACK FOOTER //
// ./src/http/http.js